<template>
    <div>
        <div class="container">
            <article>
                <div v-for="index in count" :key="index">
                    <div v-if="index == activeStep">
                        <section :class="animation">
                            <h2 v-if="hiden == false">
                                {{
                                    phase[indexPage[index - 1].PhaseId - 1].Name
                                }}
                            </h2>
                            <h2 v-if="hiden == true">
                                Finished Click to go to Answers!
                            </h2>
                            <div
                                v-if="
                                    Number(indexPage[index - 1].ShowHeader) == 1
                                "
                                class="div-header"
                                style="margin-bottom: -15px"
                            >
                                <h3>
                                    {{
                                        phase[indexPage[index - 1].PhaseId - 1]
                                            .Header
                                    }}
                                </h3>
                            </div>

                            <div
                                v-for="phaseQuestion in phaseQuestion"
                                :key="
                                    phaseQuestion.PhaseId +
                                        phaseQuestion.QuestionId
                                "
                                class="input-fields"
                                style="padding-bottom: 0.5px"
                            >
                                <div
                                    v-if="
                                        phaseQuestion.Page == activeStep &&
                                            hiden == false
                                    "
                                    class="input-container"
                                    style="padding-top: 30px"
                                >
                                    <label class="input-label">{{
                                        question[phaseQuestion.QuestionId - 1]
                                            .Text
                                    }}</label>
                                    <h1 class="radio-legend">
                                        Nicht Relevant
                                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                        &nbsp;Nein &nbsp;
                                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                        In Planung
                                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                        Vereinzelt/Pilotprojekte
                                        &nbsp;&nbsp;&nbsp;&nbsp; Ausgeprägt
                                        &nbsp;&nbsp;
                                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                        Vollumfänglich Umgesetzt/Automatisiert
                                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    </h1>

                                    <label class="radio-container">
                                        <input
                                            type="radio"
                                            v-model="phaseQuestion.created_at"
                                            value="-1"
                                        />
                                        <span class="checkmark"></span>
                                    </label>
                                    <label class="radio-container">
                                        <input
                                            type="radio"
                                            id="1"
                                            v-model="phaseQuestion.created_at"
                                            value="0"
                                        />
                                        <span class="checkmark"></span>
                                    </label>
                                    <label class="radio-container">
                                        <input
                                            type="radio"
                                            id="2"
                                            v-model="phaseQuestion.created_at"
                                            value="1"
                                        />
                                        <span class="checkmark"></span>
                                    </label>
                                    <label class="radio-container">
                                        <input
                                            type="radio"
                                            id="3"
                                            v-model="phaseQuestion.created_at"
                                            value="2"
                                        />
                                        <span class="checkmark"></span>
                                    </label>
                                    <label class="radio-container">
                                        <input
                                            type="radio"
                                            id="4"
                                            v-model="phaseQuestion.created_at"
                                            value="3"
                                        />
                                        <span class="checkmark"></span>
                                    </label>
                                    <label class="radio-container">
                                        <input
                                            type="radio"
                                            id="5"
                                            v-model="phaseQuestion.created_at"
                                            value="4"
                                        />
                                        <span class="checkmark"></span>
                                    </label>
                                    <label
                                        class="input-label"
                                        style="
                                            font-size: 0.8rem;
                                            font-weight: 600;
                                            margin-left: 10px;
                                            padding-top: 10px;
                                        "
                                        >Kommentar:</label
                                    >
                                    <input
                                        type="text"
                                        class="input-fields"
                                        style="
                                            width: 95%;
                                            margin-top: -10px;
                                            font-size: 0.8rem;
                                        "
                                        v-model="phaseQuestion.updated_at"
                                    />
                                </div>
                            </div>

                            <div class="actions">
                                <button @click="nextStep" v-if="hiden == false">
                                    Weiter
                                </button>
                                <router-link :to="'/result/overview'">
                                    <button
                                        v-if="hiden == true"
                                        style="background-color: #409dc7"
                                    >
                                        Results
                                    </button>
                                </router-link>
                            </div>
                        </section>
                    </div>
                </div>
            </article>
        </div>
    </div>
</template>

<script>
import Arrow from "../js/components/Arrow.vue";
export default {
    data: function() {
        return {
            activeStep: 1,
            description: "Results",
            answer: [],
            animation: "animate-in",
            result_id: 1,
            hiden: false,
            setting: ["Weiter", "Zurück", "Einreichen"],
            result: [],
            question: [],
            phase: [],
            indexPage: [],
            phaseQuestion: [],
            count: 0
        };
    },
    components: {
        Arrow
    },
    async created() {
        this.fetchPhase();
        await this.fetchPhaseQuestion();
        this.fetchQuestion();
    },
    methods: {
        fetchPhase() {
            let vm = this;
            axios
                .get("/api/phasesInOrderOfId")
                .then(response => {
                    this.phase = response.data;
                    console.log(this.phase);
                })
                .catch(err => console.log(err));
        },

        async fetchPhaseQuestion() {
            let vm = this;
            await axios
                .get("/api/phaseQuestions")
                .then(response => {
                    this.phaseQuestion = response.data;
                    var counter = 0;
                    for (const phaseQuestion of this.phaseQuestion) {
                        counter += 1;
                        const value =
                            phaseQuestion.PhaseId + phaseQuestion.QuestionId;
                        this.phaseQuestion[counter - 1].Score = value;
                        phaseQuestion.PhaseId + phaseQuestion.QuestionId;
                        if (Number(phaseQuestion.Page) >= Number(this.count)) {
                            this.count = Number(phaseQuestion.Page);
                        }
                    }
                    for (let i = 0; i < this.count; i++) {
                        this.indexPage[i] = {};
                        for (const phaseQuestion of this.phaseQuestion) {
                            if (Number(phaseQuestion.Page) == Number(i + 1)) {
                                this.indexPage[i].PhaseId =
                                    phaseQuestion.PhaseId;
                                this.indexPage[i].ShowHeader =
                                    phaseQuestion.ShowHeader;
                            }
                        }
                    }
                })
                .catch(err => console.log(err));
        },

        fetchQuestion() {
            let vm = this;
            axios
                .get("/api/questions")
                .then(response => {
                    this.question = response.data;
                })
                .catch(err => console.log(err));
        },
        submitStep() {
            this.hiden = true;
        },
        nextStep() {
            var test = 0;
            for (const phaseQuestion of this.phaseQuestion) {
                if (
                    Number(phaseQuestion.Page) == this.activeStep &&
                    Number(phaseQuestion.created_at) != 4 &&
                    Number(phaseQuestion.created_at) != 3 &&
                    Number(phaseQuestion.created_at) != 2 &&
                    Number(phaseQuestion.created_at) != 1 &&
                    Number(phaseQuestion.created_at) != 0 &&
                    Number(phaseQuestion.created_at) != -1
                ) {
                    test += 1;
                }
            }
            console.log(test);
            if (test == 0) {
                let vm = this;
                for (const phaseQuestion of this.phaseQuestion) {
                    if (Number(phaseQuestion.Page) == this.activeStep) {
                        axios
                            .post("/api/answer", {
                                QuestionId: phaseQuestion.QuestionId,
                                PhaseId: phaseQuestion.PhaseId,
                                Score: phaseQuestion.created_at, // inadequate use of field! -> MM - 2022-06-01
                                Comment: phaseQuestion.updated_at // inadequate use of field! -> MM - 2022-06-01
                            })
                            .then(response => {
                                vm.Feedback = "success";
                                setTimeout(() => (vm.Feedback = false), 1000);
                            })
                            .catch(err => {
                                console.log(err);
                                vm.Feedback = "fail";
                                setTimeout(() => (vm.Feedback = false), 1000);
                            });
                    }
                }
                if (this.activeStep < this.count) {
                    this.activeStep += 1;
                    window.scrollTo(0, 0);
                    console.log(this.activeStep);
                } else {
                    this.hiden = true;
                }
            } else {
                alert(
                    "There is some components missing, Please Fill All the Components!!"
                );
                test = 0;
            }
        }
    }
};
</script>

<style lang="scss" scoped>
@import url("https://fonts.googleapis.com/css?family=Noto+Sans&display=swap");
@mixin flexbox() {
    display: flex;
    justify-content: center;
    align-items: center;
}
.container {
    @include flexbox();
    width: 100%;
    font-family: "Noto Sans", sans-serif;
}
article {
    display: flex;
    align-items: center;
    margin: 10px;
    width: calc(100% - 20px);
    max-width: 15000px;
    min-height: 280px;
    perspective: 1000px;

    section {
        @include flexbox();
        align-items: center;
        flex-direction: column;
        width: 1000px;
        background-color: #fff;
        box-shadow: 0 15px 30px rgba(0, 0, 0, 0.2),
            0 10px 10px rgba(0, 0, 0, 0.2);
        h2 {
            text-align: center;
            font-size: 2rem;
            color: #179c7d;
            margin: 0px;
            padding-top: 20px;
        }
        h1 {
            text-align: center;
            font-size: 0.8rem;
            color: rgb(90, 94, 92);
        }
        .div-header {
            align-items: center;
            margin-left: 20px;
            padding-top: 10px;
            display: flex;
            h3 {
                display: flex;
                margin-left: 20px;
                font-size: 1.5rem;
                color: rgb(1, 71, 36);
            }
        }
        .input-fields {
            @include flexbox();
            flex-direction: row;
            width: 100%;
            padding-bottom: 0.4px;
        }
        .input-container {
            position: relative;
            padding: 1px 1pc 1px 1px;
            width: calc(100% - 40px);
            margin-left: 40px;

            .radio-legend {
                margin-top: 10px;
                margin-bottom: -20px;
                font-size: 0.8rem;
                font-weight: 100;
                color: rgb(0, 0, 0);
            }

            input {
                margin-bottom: 20px;
                margin-top: 20px;
                margin-right: 30px;
                margin-left: 10px;
                font-family: "Noto Sans", sans-serif;
                font-size: 1rem;
                color: #555;
                outline: none;
                border: none;
                border-bottom: 1px inset #236a66;
            }

            .radio-container {
                width: 10px;
                height: 25px;
                margin-left: 5.5%;
                margin-right: 6%;
                margin-top: 10px;
                margin-bottom: 4px;
                border-radius: 50%;
                font-size: 1rem;
                font-weight: 300;
            }

            .radio-container .checkmark {
                width: 20px;
                height: 20px;
                justify-content: center;
                align-items: center;
                border-radius: 50%;
                background-color: #222;
                display: none;
            }

            .radio-container input:checked + .checkmark {
                display: none;
            }

            input[type="radio"] {
                transform: scale(2);
            }
        }

        .input-label {
            left: 20px;
            width: 100%;
            font-size: 1.1rem;
            font-weight: 600;
            color: rgb(0, 0, 0);
            pointer-events: none;
        }

        .actions {
            display: flex;
            align-items: center;
            justify-content: center;
            margin: 0;
            button {
                font-family: "noto Sans", sans-serif;
                outline: none;
                border: none;
                color: #fff;
                background-color: #179c7d;
                font-size: 1.35rem;
                margin: 40px;
                //text-transform: uppercase;
                border-radius: 3px;
                cursor: pointer;
            }
        }
    }
}
.animate-in {
    animation: in 0.4s ease-in-out;
}
.animate-wrong {
    animation: wrong 0.6s ease-in-out;
}
</style>
